import React, { useState, useEffect, useRef } from "react"
import SessionConfig from "../../config/session_config"
import { useDispatch, useSelector } from "react-redux"
import showToast from "../../components/Common/viewNotification"
import config from "../../common/configuration"
import { formatDecimals } from "../../config/format"
import {
  Col,
  Container,
  Row,
  Card,
  CardBody,
  Input,
  CardTitle,
  InputGroup,
  UncontrolledDropdown,
} from "reactstrap"
import moment from "moment"
import "./paymentDetail.scss"
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import Select from "react-select"
import LinearIndeterminate from "../../components/Common/LinearIndeterminate"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import DataTable from "react-data-table-component"
import { getBanks, getPaymentDetail } from "../../store/actions"
import { is_empty } from "../../config/validate"
import { useTranslation } from "react-i18next"
const supplier = () => {
  const dispatch = useDispatch()
  const ref = useRef()
  const fp = useRef(null)
  const fi = useRef(null)
  const { t } = useTranslation()
  const [bank, setBank] = useState({ value: "", label: "" })
  const [currentDate, setCurrentDate] = useState(new Date())
  const [band, setBand] = useState(false)
  const [data, setData] = useState({
    startDate: new Date(),
    endDate: new Date(),
    lotNumber: "",
    firstDay: new Date(currentDate.getFullYear(), currentDate.getMonth(), 1),
    banks: [],
    page: 0,
    size: 10,
  })

  const {
    paymentDetailList,
    banks = [],
    loading,
    error,
  } = useSelector(state => {
    return {
      paymentDetailList: state?.PaymentDetail?.paymentDetails,
      banks: state?.Banks?.banks,
      loading: state.PaymentDetail.loading,
      error: state.PaymentDetail.error,
    }
  })
  useEffect(() => {
    if (!is_empty(error)) {
      showToast(error, "error", t("error:title"))
    }
  }, [error])
  useEffect(() => {
    if (banks.length)
      setBank({
        value: banks[0].id,
        label: banks[0].name,
      })
  }, [banks])
  useEffect(() => {
    if (bank.value) loadPay()
  }, [data.size, data.page])

  useEffect(() => {
    document.getElementById("body").className = "fondo2"
    initTable()
    setData({
      startDate: data.firstDay,
    })
    loadBanks()
    loadPay()
  }, [])

  useEffect(() => {
    setValueForm("startDate", {
      target: { value: moment().format("YYYY-MM-01") },
    })
  }, [])

  const loadBanks = async () => {
    await dispatch(getBanks())
  }

  const loadPay = async () => {
    const filter = {
      length: data.size,
      page: data.page,
      bankId: bank.value,
      lot_number: data.lotNumber,
      startDate: band ? data.startDate : data.firstDay,
      endDate: data.endDate,
    }
    await dispatch(getPaymentDetail({ filter }))
    setBand(true)
  }

  const updateState = (value, id) => {
    setData({
      ...data,
      [id]: value,
    })
  }

  const handlePageChange = async page => {
    data.page = parseInt(page) - 1
    if (data.page < 0) {
      data.page = 0
    }
    await updateState(data.page, "page")
  }

  const handlePerRowsChange = async (perPage, page) => {
    data.size = perPage
    data.page = parseInt(page) - 1
    if (data.page < 0) {
      data.page = 0
    }
    await updateState(data.size, "size")
    await updateState(data.page, "page")
  }
  const setValueForm = (text, value) => {
    switch (text) {
      case "startDate":
        setData({ ...data, ...{ startDate: moment(value.target.value) } })
        break
      case "lotNumber":
        setData({ ...data, ...{ lotNumber: value.target.value } })
        break
      case "endDate":
        setData({ ...data, ...{ endDate: moment(value.target.value) } })
        break
      case "page":
        setData({ ...data, ...{ page: value } })
        break
      case "size":
        setData({ ...data, ...{ size: value } })
        break
    }
  }
  const lsBanks = () => {
    if (banks.length > 0) {
      return banks?.map(item => {
        return { value: item.id, label: item.name }
      })
    } else {
      return []
    }
  }

  const initTable = () => {
    data.columns = [
      {
        name: t("paymentDetail:lot_number"),
        sortable: false,
        wrap: true,
        grow: 1,
        width: "100px",
        cell: row => <label>{row.lot_number}</label>,
      },

      {
        name: t("paymentDetail:line_number"),
        sortable: false,
        width: "60px",
        cell: row => (
          <h5 className=" badge badge-soft-dark ">{row.line_number}</h5>
        ),
      },
      {
        name: t("paymentDetail:titular_name"),
        sortable: false,
        wrap: true,
        grow: 2,
        width: "280px",
        cell: row => (
          <span>
            <div>
              <span className=" text-uppercase">{row.titular_name}</span>
            </div>
            <div className=" font-size-11 text-muted">
              {row.receiving_bank_name}
            </div>
            <div className=" badge badge-soft-primary font-size-11 ">
              {t("paymentDetail:account_number")}: {row.account_number}
            </div>
          </span>
        ),
      },
      {
        name: t("paymentDetail:date_process"),
        sortable: false,
        wrap: true,
        width: "180px",
        cell: row => (
          <h5>
            <i className="fa fa-calendar me-1 text-muted" />
            {moment(row.date_process).format("DD-MM-YYYY")}
          </h5>
        ),
      },
      {
        name: t("paymentDetail:amount"),
        sortable: false,

        grow: 1,
        width: "180px",
        right: true,
        cell: row => (
          <h5 className="text-primary ">
            {formatDecimals(
              parseFloat(row.amount).toFixed(2).toLocaleString("en")
            )}
          </h5>
        ),
      },
      {
        name: t("paymentDetail:currency"),
        sortable: false,
        width: "100px",
        grow: 1,
        cell: row => <div className=" text-muted">{row.currency.code}</div>,
      },

      {
        name: t("paymentDetail:operation_status_description"),
        sortable: false,
        wrap: true,
        grow: 1,
        cell: row => (
          <h5 className=" badge badge-soft-dark ">
            {row.operation_status_description}
          </h5>
        ),
      },
    ]
  }

  const changeBank = value => {
    if (value === null) {
      setBank({ value: "", label: "" })
    } else {
      setBank({ value: value.value, label: value.label })
    }
  }

  const onchangeDate = React.useCallback((selectedDates, dateStr, instance) => {
    if (instance?.element?.name === "startDate") {
      setData({
        ...data,
        startDate: new Date(selectedDates),
      })
    } else {
      setData({
        ...data,
        endDate: new Date(selectedDates),
      })
    }
  }, [])

  return (
    <React.Fragment>
      <SessionConfig ref={ref} />
      <div className="page-content">
        <Breadcrumbs
          title={t("global:title")}
          breadcrumbItem={t("paymentDetail:title")}
        />
        <Row>
          <Col lg="12">
            <Card>
              <CardBody>
                <CardTitle className="h5 mb-4 text-primary">
                  {t("paymentDetail:filter")}
                </CardTitle>
                <Row mb="5">
                  <Col lg={12}>
                    <Row className="d-flex align-items-end">
                      <Col md={2}>
                        <label> {t("paymentDetail:startDateFilter")}</label>
                        <InputGroup>
                          <Flatpickr
                            name="startDate"
                            className="form-control d-block"
                            value={moment(data.startDate).format("DD-MM-YYYY")}
                            options={config.form.flatpickr}
                            onChange={onchangeDate}
                            disabled={loading}
                            ref={fi}
                          />
                          <button
                            className="btn btn-primary"
                            type="button"
                            onClick={() => {
                              if (!fi?.current?.flatpickr) return
                              fi.current.flatpickr.open()
                            }}
                          >
                            <i className=" fas fa-calendar me-1 "></i>
                          </button>
                        </InputGroup>
                      </Col>

                      <Col md={2}>
                        <label> {t("paymentDetail:endDateFilter")}</label>
                        <InputGroup>
                          <Flatpickr
                            name="endDate"
                            className="form-control d-block"
                            value={data.endDate}
                            options={config.form.flatpickr}
                            onChange={onchangeDate}
                            disabled={loading}
                            ref={fp}
                          />
                          <button
                            className="btn btn-primary"
                            type="button"
                            onClick={() => {
                              if (!fp?.current?.flatpickr) return
                              fp.current.flatpickr.open()
                            }}
                          >
                            <i className=" fas fa-calendar me-1 "></i>
                          </button>
                        </InputGroup>
                      </Col>

                      <Col md={3}>
                        <label> {t("paymentDetail:bankName")}</label>
                        <Select
                          name="bank"
                          options={lsBanks()}
                          value={bank}
                          onChange={value => changeBank(value)}
                        />
                      </Col>

                      <Col md={2}>
                        <label> {t("paymentDetail:lot_number")}</label>
                        <InputGroup>
                          <Input
                            name="lotNumber"
                            type="text"
                            onChange={value => setValueForm("lotNumber", value)}
                          />
                        </InputGroup>
                      </Col>
                      <Col>
                        <div className="col-sm-auto ">
                          <UncontrolledDropdown group>
                            <button
                              type="button"
                              className="btn btn-primary save-user"
                              disabled={loading}
                              onClick={loadPay}
                            >
                              <i className=" fas fa-search me-1 " />
                            </button>
                          </UncontrolledDropdown>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <DataTable
                  title={
                    <label className="text-primary text-uppercase font-size-16">
                      <i className="fa fa-list font-size-18  me-1 " />
                      {t("paymentDetail:title_table")} {bank.label}
                    </label>
                  }
                  data={paymentDetailList.paymentDetailList || []}
                  columns={data.columns}
                  fixedHeader
                  fixedHeaderScrollHeight="500px"
                  dense
                  pointerOnHover={true}
                  highlightOnHover
                  pagination
                  paginationServer
                  paginationTotalRows={
                    paymentDetailList ? paymentDetailList.size : 0
                  }
                  paginationDefaultPage={1}
                  onChangePage={handlePageChange}
                  paginationComponentOptions={{
                    rowsPerPageText: t("tableOptions:rowsPerPageText"),
                    rangeSeparatorText: t("tableOptions:rangeSeparatorText"),
                    selectAllRowsItem: true,
                    selectAllRowsItemText: t(
                      "tableOptions:selectAllRowsItemText"
                    ),
                  }}
                  noDataComponent={t("tableOptions:noDataComponent")}
                  progressPending={loading}
                  progressComponent={<LinearIndeterminate />}
                  persistTableHead
                  onChangeRowsPerPage={handlePerRowsChange}
                  contextMessage={{
                    singular: t("tableOptions:singular"),
                    plural: t("tableOptions:plural"),
                    message: "",
                  }}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  )
}
export default supplier
